import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Form, Button, Row, Col,Input, message,
} from 'antd';
import Select from '../../components/Select';
import Container from '../../components/Container';
import {
  fetchPcLocationTypeRequest,
  fetchLocationTypeLikeRequestWhereIn,
  fetchOptions,
  fetchOptionsLike,
  driverClusterPost,
} from '../ducks';
function PickListAdvanceSearch({
  branchCodeList,
  tableFilter,
  onTableUpdate,
  advancedFilter,
  setAdvancedFilter,
  setReloadList,
  ...props
}) {
  const {
    form,
    doFetchOptions,
    doFetchPcLocationTypeRequest,
    doFetchLocationTypeLikeRequestWhereIn,
    doDriverClusterPost,
  } = props;

  const { getFieldDecorator, validateFields } = form;

  const [provinceList, setProvinceList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [clusterList, setClusterList] = useState([]);
  const [barangayList, setBarangayList] = useState([]);
  const [routeCodeList, setRouteCodeList] = useState([]);
  const [isFetching,setIsFetching] = useState(false);
  const [couriers,setCouriers] = useState([]);
  const [vehicles,setVehicles] = useState([]);
  const [vehicle,setVehicle] = useState();
  const [courier,setCourier] = useState();
  const [cluster,setCluster] = useState();
  const [minTn,setMinTn] = useState();
  const [maxTn,setMaxTn] = useState();
  const [minCwt,setMinCwt] = useState();
  const [maxCwt,setMaxCwt] = useState();
  const [province,setProvince] = useState();
  const [city,setCity] = useState();
  const [barangay,setBarangay] = useState();
  const [prio,setPrio] = useState();

  useEffect(() => {
    doFetchOptions('courier').then((res)=>{
      setCouriers(prevState => (res.payload.data.slice(0, 50)));
    });
    doFetchOptions('vehicle').then((res)=>{
      setVehicles(prevState => (res.payload.data.slice(0, 50)));
    });
    doFetchPcLocationTypeRequest('province').then((res) => {
      setProvinceList(res.payload.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
const handleSubmit = (e) => {
  
  const {doDriverClusterPost} = props;
    e.preventDefault();
    let willPost = true;
    validateFields((err, values) => {
      Object.keys(values).forEach((key) => {
        if (typeof values[key] === 'undefined') {
          willPost = false;
        }

        if (values[key] instanceof Array) {
          if (values[key].length === 0) {
            // eslint-disable-next-line no-param-reassign
            willPost = false;
            console.log(key);
          }
        }
      });
      if(willPost){
      doDriverClusterPost(values).then((res)=>{
        if(res.payload.data.code === 200){
          message.success("Successfully added driver cluster");
          props.form.resetFields();
          setReloadList(true);
        }else{
          message.error("Driver cluster already exists");
        }
      });
    }
    });
    
  };
    
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   validateFields((err, values) => {
  //     Object.keys(values).forEach((key) => {
  //       console.log(values);
  //       if (typeof values[key] !== 'undefined') {
  //         // eslint-disable-next-line no-param-reassign
  //         advancedFilter = advancedFilter.filter(obj => obj.key !== key);

  //         advancedFilter.push(
  //           {
  //             key,
  //             id: `advanced_${key}_filter`,
  //             value: values[key],
  //           },
  //         );
  //       }

  //       if (values[key] instanceof Array) {
  //         if (values[key].length === 0) {
  //           // eslint-disable-next-line no-param-reassign
  //           advancedFilter = advancedFilter.filter(obj => obj.key !== key);
  //         }
  //       }
  //     });

  //     setAdvancedFilter(advancedFilter);
  //     onTableUpdate(tableFilter);
  //   });
  // };

  const setSelectedFilter = (e, type) => {
    if (type === 'province') {
      props.form.setFieldsValue({
        city: undefined,
      });
      const params = {
        province: e,
      };

      doFetchLocationTypeLikeRequestWhereIn('city_single', params).then((res) => {
        setCityList(res.payload.data);
      });
    } else if (type === 'city') {
     

      props.form.setFieldsValue({
        cluster: undefined,
      });
      const params = {
        province: province,
        city: e,
      };
      console.log(city);
      doFetchLocationTypeLikeRequestWhereIn('cluster_single', params).then((res) => {
        setClusterList(res.payload.data);
      });
    } else if (type === 'barangay') {
       
      const params = {
        province: province,
        city: city,
        barangay: e,
      };
      doFetchLocationTypeLikeRequestWhereIn('cluster_single', params).then((res) => {
        if(typeof res.payload.data[0] !== 'undefined'){
          if(typeof res.payload.data[0].cluster_value !== 'undefined'){
            props.form.setFieldsValue({
              cluster: res.payload.data[0].cluster_value,
            });
          }
        }
      });
    }
  };
   const searchOption = (type, e) => {
    const { doFetchOptionsLike } = props;

    setIsFetching({
      isFetching: true,
    });

    doFetchOptionsLike(type, e).then((action) => {
      setIsFetching(false);
      if(type === 'courier'){
        setCouriers(prevState => (action.payload.data.slice(0, 50)));
      }else if(type === 'vehicle'){
        setVehicles(prevState => (action.payload.data.slice(0, 50)));
      }
    });
  }
  const {user} = props;
  return (
    <Container>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Col span={7}>
            <Form.Item label="Driver">
                  {getFieldDecorator('driver_id', {
                    rules: [
                      {
                        required: true,
                        message: 'Driver cannot be blank.',
                      },
                    ],
                    initialValue: undefined,
                    onChange: (e) => {
                      setCourier(e);
                      // this.getOutsourceID(e);
                      // this.setState({
                      //   driverMobile: options.courier.find(user => e === user.value).mobile_no,
                      // });
                    },
                  })(
                    <Select
                      allowClear
                      loading={isFetching}
                      options={couriers}
                      onSearch={e => searchOption('courier', e)}
                      filterOption={false}
                      placeholder="Type to search for desired driver"
                      name="driver1"
                      showSearch
                    />,
                  )}
                </Form.Item>
          </Col>  
          <Col span={7} offset={1}>
            <Form.Item label="Vehicle">
                  {getFieldDecorator('vehicle', {
                    rules: [
                      {
                        required: true,
                        message: 'Vehicle cannot be blank.',
                      },
                    ],
                    initialValue: undefined,
                    onChange: (e) => {
                      setVehicle(e);
                      // this.getOutsourceID(e);
                      // this.setState({
                      //   driverMobile: options.courier.find(user => e === user.value).mobile_no,
                      // });
                    },
                  })(
                    <Select
                      allowClear
                      loading={isFetching}
                      options={vehicles}
                      onSearch={e => searchOption('vehicle', e)}
                      filterOption={false}
                      placeholder="Type to search for desired vehicle"
                      name="vehicle"
                      showSearch
                    />,
                  )}
                </Form.Item>
          </Col>
          <Col span={7} offset={1}>
                  <Form.Item label="Maximum Tracking Numbers">
                  {getFieldDecorator('max_tn', {
                    rules: [
                      {
                        required: true,
                        message: 'Maximum Tracking Number cannot be blank.',
                      },
                    ],
                    initialValue: undefined,
                    onChange:(e)=>{
                      setMaxTn(e.target.value);
                    }
                  })(
                    <Input
                      type="number"
                      placeholder="Type to put maximum tracking numbers."
                      />,
                  )}
                </Form.Item>
          </Col>
          <Col span={7}>
            <Form.Item label="Province">
              {getFieldDecorator('province', {
                rules: [
                      {
                        required: true,
                        message: 'Province cannot be blank.',
                      },
                    ],
              })(
                <Select
                  options={provinceList}
                  onChange={e => {setSelectedFilter(e, 'province');setProvince(e)}}
                  style={{ width: '100%' }}
                  placeholder="Select province(s)..."
                />,
              )}
            </Form.Item>
          </Col>
          <Col span={7} offset={1}>
            <Form.Item label="City">
              {getFieldDecorator('city', {
                rules: [
                      {
                        required: true,
                        message: 'City cannot be blank.',
                      },
                    ],
              })(
                <Select
                  options={cityList}
                  onChange={e => {setSelectedFilter(e, 'city');setCity(e);}}
                  mode={'multiple'}
                  style={{ width: '100%' }}
                  placeholder="Select city(s)..."
                />,
              )}
            </Form.Item>
          </Col>
          <Col span={7} offset={1}>
          <Form.Item label="cluster">
              {getFieldDecorator('cluster', {
                rules: [
                      {
                        required: true,
                        message: 'Cluster cannot be blank.',
                      },
                    ],
              })(
                <Select
                  options={clusterList}
                  mode={'multiple'}
                  onChange={e => {setSelectedFilter(e, 'cluster_single');setCluster(e);}}
                  style={{ width: '100%' }}
                  placeholder="Select cluster(s)..."
                />,
              )}
            </Form.Item>
            </Col>
          {/* <Col span={7} offset={1}>
            <Form.Item label="Barangay">
              {getFieldDecorator('barangay', {
                rules: [
                      {
                        required: true,
                        message: 'Maximum Tracking Number cannot be blank.',
                      },
                    ],
              })(
                <Select
                  options={barangayList}
                  onChange={e => {setSelectedFilter(e, 'barangay');setBarangay(e);}}
                  style={{ width: '100%' }}
                  placeholder="Select barangay(s)..."
                />,
              )}
            </Form.Item>
          </Col> */}
        </Row>
        <Row>
        
          <Col span={7}>
                  <Form.Item label="Minimum CWT">
                  {getFieldDecorator('min_cwt', {
                    rules: [
                      {
                        required: true,
                        message: 'Minimum CWT cannot be blank.',
                      },
                    ],
                    initialValue: undefined,
                    onChange:(e)=>{
                      setMinCwt(e.target.value);
                    }
                  })(
                    <Input
                      type="number"
                      placeholder="Type to put minimum CWT."
                      />,
                  )}
                </Form.Item>
          </Col>
          <Col span={7} offset={1}>
                  <Form.Item label="Maximum CWT">
                  {getFieldDecorator('max_cwt', {
                    rules: [
                      {
                        required: true,
                        message: 'Maximum CWT cannot be blank.',
                      },
                    ],
                    initialValue: undefined,
                    onChange:(e)=>{
                      setMaxCwt(e.target.value);
                    }
                  })(
                    <Input
                      type="number"
                      placeholder="Type to put maximum CWT."
                      />,
                  )}
                </Form.Item>
          </Col>
          <Col span={7} offset={1}>
                  <Form.Item label="Priority">
                  {getFieldDecorator('prio', {
                    rules: [
                      {
                        required: true,
                        message: 'Driver priority cannot be blank.',
                      },
                    ],
                    initialValue: undefined,
                    onChange:(e)=>{
                      setPrio(e.target.value);
                    }
                  })(
                    <Input
                      type="number"
                      placeholder="Type to put driver priority."
                      />,
                  )}
                </Form.Item>
          </Col>
        </Row>

        <Row style={{ textAlign: 'right', marginRight: '10px' }}>
          
          <Form.Item>
            <Button
              htmlType="submit"
              type="primary"
            >
                        Add
            </Button>
          </Form.Item>
        </Row>
      </Form>
      
    </Container>
    
  );
}


PickListAdvanceSearch.propTypes = {
  form: PropTypes.oneOfType([PropTypes.object]).isRequired,
  doFetchPcLocationTypeRequest: PropTypes.func.isRequired,
  branchCodeList: PropTypes.oneOfType([PropTypes.array]).isRequired,
  doFetchLocationTypeLikeRequestWhereIn: PropTypes.func.isRequired,
  advancedFilter: PropTypes.oneOfType([PropTypes.array]).isRequired,
  tableFilter: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  onTableUpdate: PropTypes.func.isRequired,
  setAdvancedFilter: PropTypes.func.isRequired,
  doFetchOptionsLike: PropTypes.func.isRequired,
  doFetchOptions: PropTypes.func.isRequired,
  doDriverClusterPost: PropTypes.func.isRequired,
};
const mapDispatchToProps = {
  doFetchOptions: fetchOptions,
  doFetchOptionsLike:fetchOptionsLike,
  doFetchPcLocationTypeRequest: fetchPcLocationTypeRequest,
  doFetchLocationTypeLikeRequestWhereIn: fetchLocationTypeLikeRequestWhereIn,
  doDriverClusterPost: driverClusterPost,
};

const WrappedPickListAdvanceSearch = Form.create({ name: 'PickListAdvanceSearch ' })(PickListAdvanceSearch);

export default connect(null, mapDispatchToProps)(WrappedPickListAdvanceSearch);
